/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 02/05/2023.
 */
import React, { Suspense, useRef, useState } from 'react'
import { animated, useSpring, useTransition } from '@react-spring/web'
import { SpinnerFullHeight } from '../spinner/SpinnerFullHeight'

type TabViewNavigatorProps = {
  pageIndex: number
  direction: number
  children: React.ReactElement | React.ReactElement[]
}
export const TabViewNavigator = ({ pageIndex, direction, children }: TabViewNavigatorProps) => {
  const pageArr: any[] = React.Children.toArray(children)

  const [calHeight, setCalHeight] = useState(50)

  const ref = useRef<HTMLDivElement>(null)

  const transitions = useTransition(pageIndex, {
    from: { transform: `translate3d(${direction}px,0,0)`, opacity: 0 },
    enter: { transform: 'translate3d(0px,0,0)', opacity: 1 },
    leave: { transform: `translate3d(${-direction}px,0,0)`, opacity: 0 },
    onRest: (val) => {
      if (val.finished) {
        const k = ref.current ? ref.current.getBoundingClientRect().height : 0
        setCalHeight(k + 50)
      }
    },
  })

  const aniProps = useSpring({ height: calHeight, config: { tension: 400, friction: 40 } })

  //
  // Called from child page - if the child page knows its height after loading data
  //
  const onLoaded = (k) => {
    setCalHeight(k + 50)
  }

  return (
    <div className="row d-flex flex-column flex-grow-1 overflow-hidden">
      <animated.div className="position-relative w-100  " style={{ left: 0, top: 0, ...aniProps }}>
        {transitions((styles, item) => {
          return (
            <animated.div ref={ref} className="position-absolute container  " style={{ ...styles }}>
              <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                {React.cloneElement(pageArr[item], { onLoaded: onLoaded })}
              </Suspense>
            </animated.div>
          )
        })}
      </animated.div>
    </div>
  )
}
